const BrandLogoFallback = () => {
	return (
		<span
			aria-hidden="true"
			style={{ fontFamily: 'Tossface', fontSize: 20, lineHeight: 1 }}
			className="flex h-full w-full items-center justify-center rounded-full bg-mantang-gray-100"
		>
			🚗
		</span>
	);
};

export default BrandLogoFallback;
